// case
export default {
    getCurrentGamePhase(state) {
        return state.currentGamePhase
    },
    getLastEmojiCode(state) {
        return state.lastEmojiCode;
    },

    getGameClientCloseRedirectUrl(state) {
        return state.gameClientCloseRedirectUrl;
    },

    getGameClientTryReconnect(state) {
        return state.gameClientTryReconnect;
    },

    getNavigationGuardEnabled(state) {
        return state.navigationGuardEnabled;
    },

    getGameType(state) {
        return state.gameType;
    },

    getGameClientType(state) {
        return state.gameClientType;
    },

    getLicense(state) {
        return state.license;
    },

    getIsReady(state) {
        return state.isReady;
    }
}
